//@flow -strict
/**
 * Created by dv on 9/25/2017.
 */
import { DeleteZmCollectionUsersMessage, DeleteZmCollectionUsersQuery } from "../../../autogenerated/ZoomBridge";


export default class DeleteZmCollectionUsers {
  _collectionId: number;
  _user: string;
  _deleteAll: boolean;

  constructor(collectionId: number) {
    this._collectionId = collectionId;
  }

  setCollectionId(collectionId: number) {
    this._collectionId = collectionId;
    return this;
  }


  setUser(user: string) {
    this._user = user;
    return this;
  }

  setDeleteAllUsers(deleteAll: boolean) {
    this._deleteAll = deleteAll;
    return this;
  }

  /**
   * resp{GetCollectionsResponse} of Collections will be used as input to onSuccess
   * @return {Promise<boolean>}
   */
  run(): Promise<boolean> {

    const message: DeleteZmCollectionUsersMessage = new DeleteZmCollectionUsersMessage();
    message.setCollectionId(this._collectionId);
    message.setCollectionUserEntry(this._user);
    message.setDeleteAll(this._deleteAll);
    const query: DeleteZmCollectionUsersQuery = new DeleteZmCollectionUsersQuery();
    query.message = message;
    return query.run();
  }
}
